import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import {
  clearFiltersIfEmpty,
  changeAddressFilterGroup,
  changeCustomFieldsFilterGroup,
  changeMultifamilyFilterGroup,
  changePropertyFilterGroup,
  changeSaleFilterGroup,
  setAssociationFilter,
  setTags,
  selectAvailability,
  selectAssetClass,
  selectBuildingClass,
  selectInvestmentType,
  clearFilters,
  changeIndustrialFilterGroup,
} from '../store/actions/query';

import { delayRetrieveRecords } from '../store/actions/search';
import { filterLabelMappings, filterKeyMappings, leaseRateMappings, initialState } from '../research_constants';
import { hasFilters } from 'bundles/apex/custom_fields/filters/helpers';

import CurrentFiltersGroup from 'components/research_property/current_filters_group';
import PropertyCustomFieldsTags from './custom_fields_tags';

export class ResearchCurrentFiltersGroup extends React.Component {
  static propTypes = {
    addressFilter: PropTypes.object.isRequired,
    assetClasses: PropTypes.array.isRequired,
    associationFilters: PropTypes.object.isRequired,
    availabilities: PropTypes.array.isRequired,
    availableRailProviders: PropTypes.array.isRequired,
    buildingClasses: PropTypes.array.isRequired,
    clearFiltersIfEmpty: PropTypes.func.isRequired,
    customFieldFilters: PropTypes.object.isRequired,
    delayRetrieveRecords: PropTypes.func.isRequired,
    industrialFilter: PropTypes.object.isRequired,
    investmentTypes: PropTypes.array.isRequired,
    leaseSpaceTypeMappings: PropTypes.array.isRequired,
    leaseTypeMappings: PropTypes.array.isRequired,
    lotBorderTypes: PropTypes.array.isRequired,
    lotStabilizations: PropTypes.array.isRequired,
    multifamilyFilter: PropTypes.object.isRequired,
    propertyFilter: PropTypes.object.isRequired,
    saleFilter: PropTypes.object.isRequired,
    schemas: PropTypes.array.isRequired,
    selectedAssetClasses: PropTypes.array.isRequired,
    selectedAvailabilities: PropTypes.array.isRequired,
    selectedBuildingClasses: PropTypes.array.isRequired,
    selectedInvestmentTypes: PropTypes.array.isRequired,
    servedRailProviders: PropTypes.array.isRequired,
    tags: PropTypes.array.isRequired,

    onAddressFilterChange: PropTypes.func.isRequired,
    onAssetClassChange: PropTypes.func.isRequired,
    onAvailabilityChange: PropTypes.func.isRequired,
    onBuildingClassChange: PropTypes.func.isRequired,
    onClearFilters: PropTypes.func.isRequired,
    onCustomFieldsFilterChange: PropTypes.func.isRequired,
    onIndustrialFilterChange: PropTypes.func.isRequired,
    onInvestmentTypeChange: PropTypes.func.isRequired,
    onMultifamilyFilterChange: PropTypes.func.isRequired,
    onPropertyFilterChange: PropTypes.func.isRequired,
    onSaleFilterChange: PropTypes.func.isRequired,
    onSetTags: PropTypes.func.isRequired
  }

  handleRetrieveRecords = () => {
    const { clearFiltersIfEmpty, delayRetrieveRecords } = this.props;
    clearFiltersIfEmpty();
    delayRetrieveRecords();
  };

  handleAddressFilterChange = (value = '', name) => {
    const { addressFilter, onAddressFilterChange } = this.props;

    addressFilter[name] = value;
    onAddressFilterChange(addressFilter);
    this.handleRetrieveRecords();
  };

  handleClearFilters = () => {
    const {
      onClearFilters,
      delayRetrieveRecords
    } = this.props;

    onClearFilters(initialState);
    delayRetrieveRecords();
  }

  handleCustomFieldsFilterChange = (value = '', name) => {
    const { customFieldFilters, onCustomFieldsFilterChange } = this.props;

    customFieldFilters[name] = value;
    onCustomFieldsFilterChange(customFieldFilters);
    this.handleRetrieveRecords();
  };

  handleIndustrialFilterChange = (value = '', name) => {
    const { industrialFilter, onIndustrialFilterChange } = this.props;

    industrialFilter[name] = value;
    onIndustrialFilterChange(industrialFilter);
    this.handleRetrieveRecords();
  };

  handleMultifamilyFilterChange = (value = '', name) => {
    const { multifamilyFilter, onMultifamilyFilterChange } = this.props;

    multifamilyFilter[name] = value;
    onMultifamilyFilterChange(multifamilyFilter);
    this.handleRetrieveRecords();
  };

  handlePropertyFilterChange = (value = '', name) => {
    const { propertyFilter, onPropertyFilterChange } = this.props;

    propertyFilter[name] = value;
    onPropertyFilterChange(propertyFilter);
    this.handleRetrieveRecords();
  };

  handleSaleFilterChange = (value = '', name) => {
    const { saleFilter, onSaleFilterChange } = this.props;

    saleFilter[name] = value;
    onSaleFilterChange(saleFilter);
    this.handleRetrieveRecords();
  };

  handleAvailabilityChange = (id, value) => {
    const { onAvailabilityChange } = this.props;
    onAvailabilityChange(parseInt(id), value);
    this.handleRetrieveRecords();
  };

  handleAssetClassChange = (id, value) => {
    const { onAssetClassChange } = this.props;
    onAssetClassChange(parseInt(id), value);
    this.handleRetrieveRecords();
  };

  handleBuildingClassChange = (id, value) => {
    const { onBuildingClassChange } = this.props;
    onBuildingClassChange(id, value);
    this.handleRetrieveRecords();
  };

  handleInvestmentTypeChange = (id, value) => {
    this.props.onInvestmentTypeChange(id, value);
    this.handleRetrieveRecords();
  };

  handleSetTags = (tag) => {
    const { tags, onSetTags } = this.props;
    const newTags = tags.filter(t => t !== tag);
    onSetTags(newTags);
    this.handleRetrieveRecords();
  }

  render() {
    const { customFieldFilters, selectedBuildingClasses, schemas, tags, ...props } = this.props;
    let customFieldsTags;
    if (hasFilters(schemas, customFieldFilters)) {
      customFieldsTags = <PropertyCustomFieldsTags />;
    }

    return (
      <CurrentFiltersGroup
        {...props}
        buildingClasses={selectedBuildingClasses}
        filterKeyMappings={filterKeyMappings}
        filterLabelMappings={filterLabelMappings}
        filterTags={tags}
        leaseRateMappings={leaseRateMappings}
        tags={customFieldsTags}
        onAddressFilterChange={this.handleAddressFilterChange}
        onAssetClassChange={this.handleAssetClassChange}
        onAvailabilityChange={this.handleAvailabilityChange}
        onBuildingClassChange={this.handleBuildingClassChange}
        onClearFilters={this.handleClearFilters}
        onClearFilterTags={this.handleSetTags}
        onCustomFieldsFilterChange={this.handleCustomFieldsFilterChange}
        onIndustrialFilterChange={this.handleIndustrialFilterChange}
        onInvestmentTypeChange={this.handleInvestmentTypeChange}
        onMultifamilyFilterChange={this.handleMultifamilyFilterChange}
        onPropertyFilterChange={this.handlePropertyFilterChange}
        onSaleFilterChange={this.handleSaleFilterChange}
      />
    );
  }
}

const mapStateToProps = state => ({
  addressFilter: state.query.addressFilter,
  assetClasses: state.static.assetClasses,
  associationFilters: state.query.associationFilters,
  availabilities: state.static.availabilities,
  availableRailProviders: state.static.availableRailProviders,
  buildingClasses: state.static.buildingClasses,
  customFieldFilters: state.query.customFieldFilters || {},
  industrialFilter: state.query.industrialFilter,
  investmentTypes: state.static.investmentTypes,
  leaseSpaceTypeMappings: state.static.leaseSpaceTypes,
  leaseTypeMappings: state.static.leaseTypes,
  lotBorderTypes: state.static.lotBorderTypes,
  lotStabilizations: state.static.lotStabilizations,
  multifamilyFilter: state.query.multifamilyFilter,
  propertyFilter: state.query.propertyFilter,
  saleFilter: state.query.saleFilter,
  schemas: state.static.customFields,
  selectedAssetClasses: state.query.assetClasses,
  selectedAvailabilities: state.query.availabilities,
  selectedBuildingClasses: state.query.buildingClasses,
  selectedInvestmentTypes: state.query.investmentTypes,
  servedRailProviders: state.static.servedRailProviders,
  tags: state.query.tags
});

const mapDispatchToProps = {
  clearFiltersIfEmpty,
  delayRetrieveRecords,
  setAssociationFilter,
  onAddressFilterChange: changeAddressFilterGroup,
  onAssetClassChange: selectAssetClass,
  onAvailabilityChange: selectAvailability,
  onBuildingClassChange: selectBuildingClass,
  onCustomFieldsFilterChange: changeCustomFieldsFilterGroup,
  onInvestmentTypeChange: selectInvestmentType,
  onClearFilters: clearFilters,
  onIndustrialFilterChange: changeIndustrialFilterGroup,
  onMultifamilyFilterChange: changeMultifamilyFilterGroup,
  onSaleFilterChange: changeSaleFilterGroup,
  onSetTags: setTags,
  onPropertyFilterChange: changePropertyFilterGroup
};

export default connect(mapStateToProps, mapDispatchToProps)(ResearchCurrentFiltersGroup);
